import { Actions, ToggleActiveStatus, Badge } from "@";

export const TableActions = ({
  row,
  toggleActive,
  handlerEdit,
  handlerShow,
}) => {
  return (
    <>
      <Actions row={row} show={handlerShow} edit={handlerEdit} notDelete>
        <ToggleActiveStatus row={row} click={toggleActive} />
      </Actions>
    </>
  );
};

// Define table columns for user data
export const tableColumns = [
  {
    name: "العنوان",
    selector: ({ title }) => title,
  },
  {
    name: "الحالة",
    cell: ({ isActive }) => (
      <Badge
        title={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "green" : "red"}
      />
    ),
  },
];
